export const select = {
  sex: {
    title: 'Пол',
    value: {
      male: 'Мужчина',
      female: 'Женщина'
    }
  },
  select_or_type: 'Выбрать или ввести',
  required_trunk: 'Выберите источник данных'
};
